/* eslint-disable */

import React from 'react';
import Challenges from './page-components/Cases/Case/Challenges/Challenges';
import DetailsBlock from './page-components/Cases/Case/DetailsBlock/DetailsBlock';
import DevelopmentComponentsBlock from './page-components/Cases/Case/DevelopmentComponentsBlock/DevelopmentComponentsBlock';
import ProjectDetails from './page-components/Cases/Case/ProjectDetails/ProjectDetails';
import Solutions from './page-components/Cases/Case/Solutions/Solutions';
import StatsBlock from './page-components/Cases/Case/StatsBlock/StatsBlock';
import CompanyGrowth from './page-components/Company/CompanyGrowth';
import CompanyMission from './page-components/Company/CompanyMission';
import CompanyPhilosophy from './page-components/Company/CompanyPhilosophy';
import CompanyTeam from './page-components/Company/CompanyTeam';
import Mentors from './page-components/Education/Mentors';
import About from './page-components/Home/About';
import CasesBlock from './page-components/Home/CasesBlock';
import DynamicCasesBlock from './page-components/Home/CasesBlock/DynamicCasesBlock';
import Clients from './page-components/Home/Clients';
import Consultation from './page-components/Home/Consultation';
import Reviews from './page-components/Home/Reviews';
import TechStack from './page-components/Home/TechStack';
import HowWeWork from './page-components/Services/HowWeWork';
import ServicesSection from './page-components/Services/ServicesSection';
import Team from './page-components/Subservice/Team';
import Microservices from './page-components/Subservice/Microservices';
import FeatureBlock from './page-components/Cases/Case/FeatureBlock/FeatureBlock';
import DefaultScreenBlock from './page-components/Cases/Case/DefaultScreenBlock/DefaultScreenBlock';
import Info from './page-components/Info/Info';
import TeamSlider from './components/TeamSlider/TeamSlider';
import Benefits from './page-components/Services/Benefits/Benefits';
import CirclesSlider from './components/CirclesSlider/CirclesSlider';
import ServicePosts from './page-components/Services/Posts/ServicePosts';
import SocialCards from './page-components/Services/SocialCards/SocialCards';
import SubservicesList from './page-components/Services/Subservices/SubservicesList';
import StatisticTiles from './components/StatisticTiles/StatisticTiles';
import DevelopmentServicesSection from './components/DevelopmentServicesSection/DevelopmentServicesSection';
import SideRevealingPointsSection from './components/SideRevealingPointsSection/SideRevealingPointsSection';
import VideoCardSliderSection from './components/VideoCardSliderSection/VideoCardSliderSection';
import TextReviewCardSection from './components/TextReviewCardSection/TextReviewCardSection';
import ReasonsToOutsourceSection from './components/ReasonsToOutsourceSection/ReasonsToOutsourceSection';
import IndustrySection from './components/IndustrySection/IndustrySection';
import RevealingPoints from './components/RevealingPoints/RevealingPoints';
import Features from './page-components/POSTerminal/Features/Features';
import ShortCTA from './page-components/POSTerminal/ShortCTA/ShortCTA';
import VideoTour from './page-components/POSTerminal/VideoTour/VideoTour';
import IntegrationRoadmap from './page-components/POSTerminal/IntegrationRoadmap/IntegrationRoadmap';
import PriceList from './page-components/POSTerminal/PriceList/PriceList';
import Stores from './page-components/POSTerminal/Stores/Stores';
import YoutubeVideoSection from './components/YoutubeVideoSection/YoutubeVideoSection';
import AuthorQuote from './components/AuthorQuote/AuthorQuote';
import RichTextSection from './components/RichTextSection/RichTextSection';
import CaseSlider from './page-components/Cases/Case/CaseSlider/CaseSlider';
import CaseRevealingPoints from './page-components/Cases/Case/CaseRevealingPoints/CaseRevealingPoints';
import CustomTeam from './components/CustomTeam/CustomTeam';
import CalculatorCTA from './components/CalculatorCTA/CalculatorCTA';
import RevealingCaseSection from './components/RevealingCaseSection/RevealingCaseSection';
import HeaderSection from './components/HeaderSection/HeaderSection';
import VideoSection from './components/VideoSection/VideoSection';
import CTA from './components/CTA/CTA';
import HeroSection from './page-components/Home/HeroSection/HeroSection';
import SurveySection from './components/SurveySection/SurveySection';
import HomeServicesSection from './components/ServicesSection/ServicesSection';
import SuccessIndicatorsSection from './components/SuccessIndicatorsSection/SuccessIndicatorsSection';
import TeamValues from './components/TeamValues/TeamValues';
import CategorySection from './page-components/Blog/CategoriesSection/CategorySection';
import AltHeroSection from './page-components/Home/HeroSection/AltHeroSection';
import EntitiesSection from './components/SurveySection/EntitiesSection';
import ServiceSlider from './components/ServicesSlider/ServicesSlider';

import { PageSections } from './pageSections';

export { PageSections };

const pageComponents = {
  [PageSections.DynamicCasesSection]: DynamicCasesBlock,
  [PageSections.CasesSection]: CasesBlock,
  [PageSections.ReviewsSection]: Reviews,
  [PageSections.TechStackSectionDeprecated]: TechStack, 
  [PageSections.TechStackSection]: TechStack,
  [PageSections.ClientsSection]: Clients,
  [PageSections.HowWeWorkSection]: HowWeWork,
  [PageSections.ConsultationSection]: Consultation,
  [PageSections.AboutSection]: About,
  [PageSections.ServicesSectionDeprecated]: ServicesSection,
  [PageSections.ServicesSection]: ServicesSection,
  [PageSections.MicroserviceSection]: Microservices,
  [PageSections.TeamSection]: Team,
  [PageSections.ChallengesSection]: Challenges,
  [PageSections.ProjectDetailsSection]: ProjectDetails,
  [PageSections.SolutionsSection]: Solutions,
  [PageSections.StatsSection]: StatsBlock,
  [PageSections.DetailsSection]: DetailsBlock,
  [PageSections.DevelopmentComponentsSection]: DevelopmentComponentsBlock,
  [PageSections.LeadershipSection]: Mentors,
  [PageSections.PeopleGrowthSection]: CompanyGrowth,
  [PageSections.CompanyMissionSection]: CompanyMission,
  [PageSections.CompanyTeamSection]: CompanyTeam,
  [PageSections.CompanyPhilosophySection]: CompanyPhilosophy,
  [PageSections.CaseScreenBlock]: DefaultScreenBlock,
  [PageSections.CaseFeatureSection]: FeatureBlock,
  [PageSections.CaseDeliveredValues]: Microservices,
  [PageSections.InfoSection]: Info,
  [PageSections.TeamSliderSection]: TeamSlider,
  [PageSections.BenefitsSection]: Benefits,
  [PageSections.CirclesSlider]: CirclesSlider,
  [PageSections.ServicePosts]: ServicePosts,
  [PageSections.SocialCardsSection]: SocialCards,
  [PageSections.RevealingServicesSection]: SubservicesList,
  [PageSections.StatisticSection]: StatisticTiles,
  [PageSections.RevealingPointsSection]: RevealingPoints,
  [PageSections.ServiceTilesSection]: DevelopmentServicesSection,
  [PageSections.ExpandedRevealingPoints]: SideRevealingPointsSection,
  [PageSections.VideoCardSliderSection]: VideoCardSliderSection,
  [PageSections.CtaReviewSections]: TextReviewCardSection,
  [PageSections.NumberedListSection]: ReasonsToOutsourceSection,
  [PageSections.IndustryTilesSection]: IndustrySection,
  [PageSections.ReviewsListSection]: Reviews,
  [PageSections.FeaturesSection]: Features,
  [PageSections.ShortCTASection]: ShortCTA,
  [PageSections.VideoTourSection]: VideoTour,
  [PageSections.SimpleTextVideoSection]: VideoTour,
  [PageSections.IntegrationRoadmapSection]: IntegrationRoadmap,
  [PageSections.PriceListSection]: PriceList,
  [PageSections.StoresSection]: Stores,
  [PageSections.CasesRevealingSection]: RevealingCaseSection,
  [PageSections.CTASection]: CalculatorCTA,
  [PageSections.TitleDescriptionSection]: HeaderSection,
  [PageSections.RevealingCasesHeaderSection]: HeaderSection,
  [PageSections.VideoSection]: VideoSection,
  [PageSections.YoutubeVideoSection]: YoutubeVideoSection,
  [PageSections.AuthorQuoteSection]: AuthorQuote,
  [PageSections.RichTextSection]: RichTextSection,
  [PageSections.CustomTeamSection]: CustomTeam,
  [PageSections.CaseSliderSection]: CaseSlider,
  [PageSections.CaseRevealingPointsSection]: CaseRevealingPoints,
  [PageSections.CalculatorCTA]: CTA,
  [PageSections.HomePageHero]: HeroSection,
  [PageSections.HomePageSlider]: SuccessIndicatorsSection,
  [PageSections.HomePageServices]: HomeServicesSection,
  [PageSections.HomePageTeamGrid]: TeamValues,
  [PageSections.BlogArticlesSection]: CategorySection,
  [PageSections.SurveySection]: SurveySection,
  [PageSections.AltHomePageHero]: AltHeroSection,
  [PageSections.EntitiesSection]: EntitiesSection,
  [PageSections.ServiceSLiderSection]: ServiceSlider
};

type PageSectionProps = {
  name: PageSections;
  props: object;
  children?: React.ReactNode;
};  
export const getPageSection = ({ name, props, children }: PageSectionProps) => {
  const SectionComponent = pageComponents[name as PageSections];
  // @ts-ignore props is missing error because of props destructuring
  return SectionComponent && <SectionComponent {...props}>{children}</SectionComponent>;
};
